import DocumentList from "./DocumentList";

export default function PaymentVerificationList() {
  return <DocumentList variant="verification" />;
}
